import requests from "./httpService";

const VendorLedgerServices = {
  getAllVendorName: async () => {
    return requests.get(`/vendor/company-name`);
  },

  getVendorLedger: async (vendor_id, body) => {
    const query = new URLSearchParams(body || {}).toString();
    return requests.get(`/vendor/ledger/${vendor_id}${query ? `?${query}` : ""}`);
  },
};

export default VendorLedgerServices;
